import { Button, Paragraph, Popup } from '@quickmd-llc/design-system'

interface DeleteLicensePopupProps {
  stateName: string
  onConfirm: () => void
  onCancel: () => void
}

export function DeleteLicensePopup({ stateName, onConfirm, onCancel }: DeleteLicensePopupProps) {
  return (
    <Popup
      isOpen
      onClose={onCancel}
      header={{ title: 'Delete license' }}
      body={
        <Paragraph>
          Are you sure you want to delete the license for <strong>{stateName}</strong>? This action cannot be undone.
        </Paragraph>
      }
      footer={
        <div className='flex justify-end gap-sp-1'>
          <Button priority='secondary' onClick={onCancel}>
            Cancel
          </Button>
          <Button priority='primary' theme='warning' onClick={onConfirm}>
            Delete
          </Button>
        </div>
      }
    />
  )
}
